<template>
  <v-dialog v-model="dialogIsOpen" max-width="800" style="display: flex">
    <v-card>
      <v-card-title class="headline"> öV-Pad WebApp Release Notes</v-card-title>
      <v-card-text>
        <v-btn outlined rounded @click="exportAsTxt">{{ $t('copyToClipboard') }}</v-btn>
      </v-card-text>
      <v-card-text style="height: 70vh; overflow-y: scroll">
        <div class="d-flex flex-column">
          <div v-for="v in versions" :key="v.version">
            <div class="text-h6 pt-7">Version {{ v.version }}</div>
            <div v-if="hasOnlyOtherCustomersChanges(v, tenant)" class="">{{ $t('customizingOtherTenant') }}</div>
            <v-row v-else class="d-flex pt-3 full-width" v-for="(change, ind) in v.changes" :key="ind">
              <template v-if="!change.tenant || change.tenant === tenant">
                <div v-if="change.ticket && change.ticket.toLowerCase() !== 'kein ticket'" class="d-flex ticket">
                  {{ change.ticket }}
                </div>
                <div v-else-if="change.zend && change.zend !== 'Kein Ticket'" class="d-flex ticket">
                  {{ change.zend }}
                </div>
                <div class="d-flex title-text">
                  <div class="subtitle-2">{{ change.title }}</div>
                  <div>{{ change.text }}</div>
                </div>
              </template>
              <template></template>
            </v-row>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" rounded @click="$emit('input', false)">
          {{ $t('close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import releaseNotes from '@/releaseNotes.js';
import config from '@/common/config';

export default {
  name: 'ReleaseNotesDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogIsOpen: this.value,
      displayedReleaseVersion: releaseNotes[releaseNotes.length - 1].version,
    };
  },
  methods: {
    async exportAsTxt() {
      let text = this.versions
        .map((v) => {
          let version = `
========================
Version ${v.version}
========================`;
          let changes = v.changes
            .filter((change) => !change.tenant || change.tenant === this.tenant)
            .map(
              (c) => `
${c.ticket ? c.ticket : 'kein Ticket'} - ${c.title}
${c.text}

          `
            )
            .join('');
          return version + changes;
        })
        .join('');
      console.debug('exportAsTxt', text);
      await navigator.clipboard.writeText(text);
    },
    hasOnlyOtherCustomersChanges(version, tenant) {
      //console.debug("hasOnlyOtherCustomersChanges",version)
      let generalOrOwnChanges = version.changes.filter((c) => {
        if (!c.tenant) return true; // general change
        if (c.tenant === tenant) return true; // own change
        return false;
      });
      return generalOrOwnChanges.length === 0;
    },
  },
  computed: {
    appVersion: () => config.appVersion,
    versions() {
      return releaseNotes.filter((v) => {
        let changes = v.changes;
        // .filter((change) => !change.tenant || change.tenant === this.tenant);
        return changes.length > 0;
      });
    },
    tenant: () => config.tenant,
  },
  watch: {
    dialogIsOpen(newValue, oldValue) {
      console.debug('dialogIsOpen changed:', newValue);
      this.$emit('input', newValue);
    },
    value(newValue, oldValue) {
      console.debug('value changed');
      this.dialogIsOpen = newValue;
    },
  },
};
</script>
<style scoped>
.ticket {
  display: flex;
  width: 100%;
  padding-left: 14px;
}

.title-text {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-left: 14px;
}
</style>
